import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MaterialReactTable from "material-react-table";
import {
    faArrowLeft,
    faEye,
    faImage,
} from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import { useNavigate, useLocation } from "react-router-dom";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
// import "../../assets/styles/FarmerDetailView.css";
import AdminHeaderNew from "../NewAdminPanel/Common/AdminHeader";
import AdminSideBarNew from "../NewAdminPanel/Common/AdminSideBar";
import AdminFooterNew from "../NewAdminPanel/Common/AdminFooter";

const containerStyle = {
    width: "100%",
    height: "50vh",
};

const center = {
    lat: 28.641832439372656,
    lng: 77.22480777651072,
};

function GeoJsonShow() {
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [isFetching, setIsFetching] = useState(true);
    const [geojsonData, setgeojsonData] = useState([]);
    const [LoaderGeoJson, setLoaderGeoJson] = useState(false);
    const downloadFile = ({ data, fileName, fileType }) => {
        // Create a blob with the data we want to download as a file
        const blob = new Blob([data], { type: fileType })
        // Create an anchor element and dispatch a click event on it
        // to trigger a download
        const a = document.createElement('a')
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }
    const replaceHyphens = (str) => {
        return str.replace(/-+/g, ''); // Regular expression to replace multiple hyphens
    };
    function exportToJson(geojsonData) {
        let startdates = replaceHyphens(startDate.toString());
        let endDates = replaceHyphens(endDate.toString());

       
        const  jsonString = JSON.stringify(geojsonData);
        console.log("jsonString!!!!",jsonString);
        downloadFile({
            data: geojsonData,
            fileName: 'Geo_Json' +sessionStorage.getItem("schemeCodeModel")+ startdates + '_' + endDates + '.json',
            fileType: 'json',
        })
      
    }

    function handleFilter() {

        if (document.getElementById("startDate").value == "") {
            alert('Fill Start Date');
            return false;
        }
        else if (document.getElementById("endDate").value == "") {
            alert('Fill End Date');
            return false;
        }
        else {
            fetchData();
        }
    }
    function handleClearFilter() {
        setStartDate("")
        setEndDate("")
        document.getElementById("startDate").value = "";
        document.getElementById("endDate").value = "";
        document.getElementById("findBtn").disabled = false;

    }


    const fetchData = async () => {
        setLoaderGeoJson(true);
        setgeojsonData([]);
        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "12") {
        result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsPolygonGeoJson`, {

            "StartDate": startDate,
            "EndDate": endDate,
            "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
            "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel")
        }
        );
        }
        else
        {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/CropInsurance/GetSurveyDetailsCHPolygonGeoJson`, {

                "StartDate": startDate,
                "EndDate": endDate,
                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel")
            } );
        }
        console.log("result.data.dataContent[0].geojson !!!!!!!!!!!!!",result.data.dataContent[0].geojson);
       console.log('reeeeee',result.data.success);
        if(result.data.success===true)
        {
            
        setgeojsonData(result.data.dataContent[0].geojson); // Set state here
        setIsFetching(false);
        setLoaderGeoJson(false);
           
            console.log("test data",geojsonData);
        }
        else
        {
            if (geojsonData && geojsonData.length > 0) {
            }
            else
            {
                alert('something went wrong.');
                setLoaderGeoJson(false);
            }
           
        
        }


    };

    useEffect(() => {
        // Only call exportToJson when geojsonData has been updated
        if (geojsonData && geojsonData.length > 0) {
         // console.log('geojsonData.length !!!', geojsonData.length);
          exportToJson(geojsonData);
         // console.log("test data", geojsonData);
        }
      }, [geojsonData]); // Dependency array to listen for changes in geojsonData
    
    


    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarNew />
            <main id="main" className="main">
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                    {sessionStorage.getItem("schemeCodeModel") === "12" || sessionStorage.getItem("schemeCodeModel") === "13" ? (
                        <nav>
                            <h1>Geo Json Details</h1>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">Geo Json</li>
                                <li className="breadcrumb-item active">Geo Json Details</li>
                            </ol>
                        </nav>
                    ) : (<nav>
                        <h1>Farmer List</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Farmer 123List</li>
                            <li className="breadcrumb-item active">Farmer</li>
                        </ol>
                    </nav>)}
                </div>
                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <form className="row g-3">
                                        <div className="col-md-2">
                                            <label htmlFor="startdate" className="form-label">Start Date</label>
                                            <input type="date" className="form-control" id="startDate" max={endDate} onChange={e => setStartDate(e.target.value)} />
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="enddate" className="form-label">End Date</label>
                                            <input type="date" className="form-control" id="endDate" min={startDate} onChange={e => setEndDate(e.target.value)} />
                                        </div>
                                    </form>
                                    <br/>
                                    
                            
                                    <div className="col-md-12 d-flex justify-content-md-left">

                                        <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={handleFilter} id="findBtn">Download</button>
                                        <button type="button" className="btn btn-success me-md-2" onClick={handleClearFilter} id="clearBtn">Clear</button>
                                    </div>
                                </div>

                            </div>


                        </div>


                    </div>
                </section>
                {LoaderGeoJson === false ? "" : <div class="overlay">
                    <div class="overlay__inner">
                        <div class="overlay__content"><span class="spinner"></span></div>
                    </div>
                </div>}
            </main>
        </>
    )
}



export default React.memo(GeoJsonShow);